﻿(function (angular, ToyotaForms) {
  "use strict";

  angular.module("Toyota.Directives").directive("formsRegisterMyInterest", [
    "$filter",
    "API",
    "SitecoreAnalytics",
    function ($filter, API, SitecoreAnalytics) {
      formsRegisterMyInterestController.$inject = ["$scope", "ParseBool"];
      function formsRegisterMyInterestController($scope, ParseBool) {
        var fc = this;

        //this line of code is absolutely required. some other parts of the code are utilizing it
        $scope.JSON = JSON;

        $scope.init = function () {
          $scope.fields = {
            firstname: "",
            lastname: "",
            phone: "",
            email: "",
            carSelectionOne: "",
            carSelectionTwo: "",
            formName: "",
            campaignCode: "",
            interestedInFinance: false,
            interestedInFleet: false,
            interestedInTradeIn: false,
            agreement: false,
            contactedByDealership: null,
            dealer: {
              dealerCode: "",
              branchCode: "",
              address: "",
              name: "",
              postCode: "",
              suburb: "",
              state: "",
              telephone: "",
              email: "",
            },
            dealerSelected: false,
            buyingTimeline: "",
            vehicleForBusinessOption: "",
            vehicleForBusinessOptionLabel: "",
            abnNumber: "",
            companyName: "",
          };

          $scope.form = {
            submitting: false,
            completed: false,
            success: false,
          };

          $scope.vehicleModelList = [];
        };

        $scope.init();

        var resetField = function (fieldId) {
          if (!$scope.wfm[fieldId]) {
            return;
          }

          $scope.wfm[fieldId].$touched = false;
          $scope.wfm[fieldId].$untouched = true;
        };

        $scope.reset = function () {
          $scope.fields = {
            firstname: "",
            lastname: "",
            phone: "",
            email: "",
            carSelectionOne: $scope.fields.carSelectionOne,
            carSelectionTwo: $scope.fields.carSelectionTwo,
            formName: $scope.fields.formName,
            campaignCode: $scope.fields.campaignCode,
            interestedInFinance: false,
            interestedInFleet: false,
            interestedInTradeIn: false,
            agreement: false,
            contactedByDealership: null,
            dealer: {
              dealerCode: "",
              branchCode: "",
              address: "",
              name: "",
              postCode: "",
              suburb: "",
              state: "",
              telephone: "",
              email: "",
            },
            dealerSelected: false,
            buyingTimeline: "",
            vehicleForBusinessOption: "",
            vehicleForBusinessOptionLabel: "",
            abnNumber: "",
            companyName: "",
          };

          $scope.form = {
            submitting: false,
            completed: false,
            success: false,
          };

          $scope.vehicleModelList = [];

          $scope.wfm.$submitted = false;

          resetField("firstname");
          resetField("lastname");
          resetField("phone");
          resetField("email");
          resetField("abnNumber");
          resetField("companyName");
          resetField("buyingTimeline");
          resetField("vehicleForBusinessOption");
          resetField("vehicleForBusinessOptionLabel");
          resetField("findADealer");
        };

        $scope.setPreferredDealer = function (dealer) {
          $scope.fields.dealerSelected = true;
          $scope.fields.dealer.dealerCode = dealer.dealerCode;
          $scope.fields.dealer.branchCode = dealer.branchCode;
          $scope.fields.dealer.name = dealer.name;
          $scope.fields.dealer.address = dealer.address;
          $scope.fields.dealer.suburb = dealer.city;
          $scope.fields.dealer.postCode = dealer.postCode;
          $scope.fields.dealer.state = dealer.state;
          $scope.fields.dealer.telephone = dealer.telephone;
          $scope.fields.dealer.email = dealer.email;
        };

        $scope.getData = function () {
          var formData = {
            FirstName: $scope.fields.firstname,
            LastName: $scope.fields.lastname,
            Email: $scope.fields.email,
            Phone: $scope.fields.phone,
            CarSelectionOne: $scope.fields.carSelectionOne,
            CarSelectionTwo: $scope.fields.carSelectionTwo,
            FormName: $scope.fields.formName,
            CampaignCode: $scope.fields.campaignCode,
            Subscribe: $("#terms-checkbox").length ? $scope.fields.agreement : true,
            BuyingTimeLine: $scope.fields.buyingTimeline,
            FleetSize: $scope.fields.vehicleForBusinessOption,
            FleetSizeLabel: $scope.fields.vehicleForBusinessOptionLabel,
            ABNNumber: $scope.fields.abnNumber,
            CompanyName: $scope.fields.companyName,
            IsOptOutToBeContactedBySalesPerson: $scope.fields.contactedByDealership === "true" ? false : true
          };

          if (ParseBool(fc.showDealerLocator)) {
            var dealerInfo = {
              Dealer: {
                Id: $scope.fields.dealer.dealerCode,
                BranchId: $scope.fields.dealer.branchCode,
                Name: $scope.fields.dealer.name,
                Address: $scope.fields.dealer.address,
                State: $scope.fields.dealer.state,
                Postcode: $scope.fields.dealer.postCode,
                Suburb: $scope.fields.dealer.suburb,
                Telephone: $scope.fields.dealer.telephone,
                Email: $scope.fields.dealer.email,
              },
            };
            angular.extend(formData, dealerInfo);
          }

          if ($("#interested-in-finance-checkbox").length) {
            angular.extend(formData, {
              InterestedInFinance: $scope.fields.interestedInFinance,
            });
          }

          if ($("#interested-in-fleet-checkbox").length) {
            angular.extend(formData, {
              InterestedInFleet: $scope.fields.interestedInFleet,
            });
          }

          if ($("#interested-in-tradeIn-checkbox").length) {
            angular.extend(formData, {
              InterestedInTradeIn: $scope.fields.interestedInTradeIn,
            });
          }

          return formData;
        };

        $scope.setVehicleForBusinessOptionLabel = function (label) {
          $scope.fields.vehicleForBusinessOptionLabel = label;
        };

        $scope.validateOtherVehicles = function (thisVehicle) {
          switch (thisVehicle) {
            case $scope.vehicleModelList[0]:
              try {
                $scope.wfm[$scope.vehicleModelList[1]].$validate();
              } catch (e) {
                // no errors if the fields don't exist
              }

              break;

            case $scope.vehicleModelList[1]:
              try {
                $scope.wfm[$scope.vehicleModelList[0]].$validate();
              } catch (e) {
                // no errors if the fields don't exist
              }

              break;
          }
        };

        $scope.vehicleInvalid = function (fieldId) {
          // only validate while the user is filling the form
          if (!$scope.wfm[fieldId].$touched && !$scope.wfm.$submitted) {
            return false;
          }

          return !$scope.wfm[fieldId].$valid;
        };

        $scope.vehicleValid = function (fieldId) {
          // only validate while the user is filling the form
          if (!$scope.wfm[fieldId].$touched) {
            return false;
          }

          return $scope.wfm[fieldId].$valid;
        };

        $scope.submit = function (goalId) {
          if ($scope.form.submitting) {
            return;
          }

          SitecoreAnalytics.triggerGoal(goalId);

          $scope.form.submitting = true;

          var url = $filter("formatArgs")(ToyotaForms.API.FormSubmission.RegisterMyInterest);
          var data = $scope.getData();

          API.post(url, data).then(
            function (req) {
              $scope.form.submitting = false;

              if (req.data.isSuccessful) {
                $scope.form.completed = true;
                $scope.form.success = true;
              } else {
                $scope.form.completed = true;
                $scope.form.success = false;
              }

              if ($scope.form.completed && $scope.form.success) {
                $scope.$broadcast("form-success");
              } else {
                $scope.$broadcast("form-failure");
              }
            },
            function () {
              $scope.form.completed = true;
              $scope.form.success = false;
              $scope.$broadcast("form-server-error");
            }
          );
        };
      }

      return {
        restrict: "A",
        controller: formsRegisterMyInterestController,
        controllerAs: "fc",
        bindToController: {
          showDealerLocator: "@formsRegisterMyInterestShowDealer",
        },
        link: function (scope, element, attr, ctrl) {
          var ATTR_MODAL = "[data-ty-modal]";
          var ATTR_MODAL_CLOSE = "[data-ty-modal-close]";

          angular.forEach(element.find("ui-select"), function (ele) {
            var id = angular.element(ele).attr("id");
            scope.vehicleModelList.push(id);
          });

          // re-initalise the form if a parent modal is closed
          window.addEventListener("load", () => {
            angular.forEach(element.closest(ATTR_MODAL).find(ATTR_MODAL_CLOSE), function (ele) {
              angular.element(ele).on("click", function () {
                scope.reset();
                scope.$apply();
              });
            });
          });
        },
      };
    },
  ]);
})(window.angular, window.ToyotaForms);
